import { useEffect } from "react";
import { getlistAmount } from "../store/slices/listAmountSlice";
import { useDispatch, useSelector } from "react-redux";

export const useListAmount = () => {
  const dispatch = useDispatch();
  const listAmountData = useSelector((state) => state.listAmount);
  const tokenStatus = useSelector((state) => state.token.status);

  useEffect(() => {
    if (tokenStatus === "succeeded" && listAmountData.status === "idle") {
      dispatch(getlistAmount());
    }
  }, [tokenStatus]);

  return {
    listAmountData: listAmountData?.listAmountData,
  };
};
